// extracted by mini-css-extract-plugin
export default {"params":"Searchcrumb_params__j5IGk","param":"Searchcrumb_param__k-3d1"};